export const psych = (() => {
    const placeHolderText = 'Clear mentation, no depression or anxiety.  No suicidality'

    return placeHolderText
})